import { Link, useLocation } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

const routeLabelMap: Record<string, string> = {
  '/': '首页',
  '/about': '关于我们',
};

const categoryNameMap: Record<string, string> = {
  'caodi-jingji': '草地竞技',
  'caoyuan-saidai': '草园赛道',
  'ludi-taofa': '绿地挑战',
  'zonghe-saishi': '综合赛事',
  'xinren-rumen': '新人入门',
  'gaoji-jijie': '高级技巧',
};

function buildCrumbs(pathname: string): Crumb[] {
  const crumbs: Crumb[] = [{ label: '首页', to: '/' }];
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length === 0) return crumbs;

  if (segments[0] === 'category') {
    crumbs.push({ label: '赛事分类', to: '/category/caodi-jingji' });
    if (segments[1]) {
      crumbs.push({ label: categoryNameMap[segments[1]] || segments[1] });
    }
  } else if (segments[0] === 'article') {
    crumbs.push({ label: '赛事资讯' });
    if (segments[1]) {
      crumbs.push({ label: '文章详情' });
    }
  } else if (segments[0] === 'about') {
    crumbs.push({ label: '关于我们' });
  }

  return crumbs;
}

export default function Breadcrumb() {
  const location = useLocation();
  const crumbs = buildCrumbs(location.pathname);

  if (crumbs.length <= 1) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.label,
      item: crumb.to ? `https://williamallen.cn${crumb.to}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
        <ol className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
          {crumbs.map((crumb, index) => (
            <li key={index} className="flex items-center gap-2">
              {index > 0 && <i className="ri-arrow-right-s-line text-xs"></i>}
              {crumb.to ? (
                <Link to={crumb.to} className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-foreground-700 font-medium">{crumb.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}